import React from 'react';
// import AppImage from '../AppImage';
import Loader from '../Loader';
import styles from './styles.module.scss';
import { AdminContext } from '../../context/AdminContext';
import { useContext } from 'react';

const SimpleFormInput = ({
  type = 'text',
  onChange,
  className = '',
  placeholder,
  value,

  error,

  showProfileError = false,

  maxLength,
  inputStyle = styles.inputStyle,
  prefixClass = styles.prefix,
  affixClass = styles.affix,
  prefix,
  wraperClassName = 'nothing',
  inputTitleClass,
  onFocus,
  onBlur,
  errorProfile,

  loading = false,

  children,
  affix,
  disabled = false,
  prefix0,

  extraInfoStyle = styles.extraInfoStyle,
  showInput = true,

  id,

  onKeyDown = () => console.log('keydown'),

  title = null,
  extraInfo = null,
}) => {
  const { themeColor } = useContext(AdminContext);

  return (
    <div className={`${styles.container}${` `}${className}`}>
      <div className={`flex flex-row justify-between items-center w-full`}>
        {title && (
          <p className={inputTitleClass ? inputTitleClass : styles.inputTitle}>
            {title}
            {extraInfo && <span className={extraInfoStyle}>{extraInfo}</span>}
          </p>
        )}
        {children && <div>{children}</div>}
        {showProfileError && loading && (
          <div
            className={`flex flex-row justify-start align-center w-auto h-auto`}
          >
            <p
              className={`${styles.inputErrorProfile} preserveWhiteThemeColor`}
            >
              در حال بررسی نام
            </p>

            <Loader
              className={styles.lds_ring}
              width={'w-20px'}
              height={'h-20px'}
            />
          </div>
        )}
        {showProfileError && !loading && (
          <div
            className={`flex flex-row justify-start align-center w-auto h-auto`}
          >
            <p
              className={`${styles.inputErrorProfile} preserveWhiteThemeColor`}
            >
              {errorProfile}
            </p>

            <img
              width={20}
              height={20}
              src='/imgs/profile/warning.svg'
              alt='warning'
              className={` ${themeColor != 'white' && 'makeWhite'}`}
            />
          </div>
        )}
      </div>
      <div
        className={`${styles.wrapper} ${wraperClassName} selectButton ${
          error && styles.yellowBorder
        } `}
      >
        {prefix0 && (
          <div
            className={`${prefixClass}  ${
              themeColor != 'white' && 'makeWhite'
            }`}
          >
            {prefix0}
          </div>
        )}
        {showInput && (
          <input
            type={type}
            className={inputStyle ? inputStyle : styles.inputStyle}
            onChange={onChange}
            placeholder={placeholder}
            value={value}
            onFocus={onFocus}
            onBlur={onBlur}
            maxLength={maxLength}
            disabled={disabled}
            onKeyDown={onKeyDown}
            autoComplete='on'
            id={id}
            name={id}
          />
        )}

        {prefix && (
          <div
            className={`${prefixClass} ${themeColor != 'white' && 'makeWhite'}`}
          >
            {prefix}
          </div>
        )}
        {affix && (
          <div
            className={`${affixClass} ${themeColor != 'white' && 'makeWhite'}`}
          >
            {affix}
          </div>
        )}
      </div>
      {error && (
        <p className={`${styles.inputError} preserveWhiteThemeColor`}>
          {error}
        </p>
      )}
    </div>
  );
};

export default SimpleFormInput;
